fdom.apis.set('core.logmanager', {
    'constructor': {
        value: []
    },
    'getEncrypedLogBuffer': {
        type: 'method',
        value: [['array', 'string']],
        ret: 'buffer'
    },
    'getLogs': {
        type: 'method',
        value: [['array', 'string']],
        ret: ['array', 'string']
    },
    'clearLogs': {
        type: 'method',
        value: []
    },
    'enable': {
        type: 'method',
        value: []
    },
    'disable': {
        type: 'method',
        value: []
    },
    'setConsoleFilter': {
        type: 'method',
        value: [['array', 'string']]
    }
});
fdom.apis.register('core.logmanager', Freedom_UproxyLogging.LogManager);
fdom.apis.set('core.log', {
    'constructor': {
        value: ['string']
    },
    'debug': {
        type: 'method',
        value: ['string', ['array', 'object']]
    },
    'info': {
        type: 'method',
        value: ['string', ['array', 'object']]
    },
    'warn': {
        type: 'method',
        value: ['string', ['array', 'object']]
    },
    'error': {
        type: 'method',
        value: ['string', ['array', 'object']]
    }
});
fdom.apis.register('core.log', Freedom_UproxyLogging.Log);
//# sourceMappingURL=logger.fdom-interface.js.map